import Vue from 'vue'
import Vuex from 'vuex'
// import { loginApi, logoutApi } from '@/api/login'
import { loginApi } from '@/api/login'
import { getInfoApi } from '@/api/login'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    userInfo: {}
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INFO: (state, info) => {
      state.userInfo = info
    }
  },
  actions: {
    // 登录
    Login({ commit }, info) {
      return new Promise((resolve, reject) => {
        loginApi(info)
          .then(res => {
            if (res.code == 0) {
              const result = res.data
              commit('SET_TOKEN', result.token)
              window.localStorage.setItem('token', result.token)
              resolve()
            } else {
              reject(res.msg)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 登出
    Logout({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_INFO', {})
        window.localStorage.removeItem('token')
        resolve()
      })
    },
    // 登出
    // Logout({ commit, state }) {
    //   return new Promise(resolve => {
    //     logoutApi(state.token)
    //       .then(() => {
    //         commit('SET_TOKEN', '')
    //         window.localStorage.removeItem('token')
    //         resolve()
    //       })
    //       .catch(err => {
    //         console.log('logout fail:', err)
    //       })
    //   })
    // },
    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfoApi()
          .then(res => {
            if (res.code == 0) {
              commit('SET_INFO', res.data)
              resolve()
            } else {
              reject(res.msg)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
})
